import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Wraps admin routes that MODERATOR must not access; redirects them to /admin.
export default function AdminFullGuard() {
  const { user } = useAuth();
  if (user?.role === "MODERATOR") return <Navigate to="/admin" replace />;
  return <Outlet />;
}
